import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FieldComponent from './FieldComponent';
import Condition from '../../services/Condition';
import './FormViewComponent.scss';

class FormViewComponent extends React.Component {
  static propTypes = {
    selectedScenario: PropTypes.shape({}),
    data: PropTypes.shape({}).isRequired,
    dataService: PropTypes.shape({}).isRequired,
    viewService: PropTypes.shape({}).isRequired,
    properties: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    readOnly: PropTypes.bool,
    onPropertyChange: PropTypes.func,
    configuration: PropTypes.shape({
      row: PropTypes.bool,
      full: PropTypes.bool,
      className: PropTypes.string,
    }),
  }

  static defaultProps = {
    selectedScenario: null,
    readOnly: false,
    configuration: undefined,
    onPropertyChange: undefined,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.state = {
      ...this.updateFromProperties(props),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.properties !== prevProps.properties) {
      this.setState(this.updateFromProperties(this.props));
    }
  }

  handleChange = name => (event) => {
    const property = this.props.properties.find(p => p.name === name);
    const { data } = this.props;
    if (property && data) {
      const eventToValue = (e) => {
        return e && e.target ? e.target.value : e;
      };
      const value = property.type === 'boolean' ? !data[property.name] : eventToValue(event);
      this.props.onPropertyChange(name, value);
    }
  };

  updateFromProperties(props) {
    const conditions = {};
    const { properties, viewService } = props;
    properties.forEach((property) => {
      if (property.if) {
        conditions[property.name] = Condition(property.if, properties, viewService);
      }
    });
    return { conditions };
  }

  render() {
    const { properties, data, configuration = {} } = this.props;
    const { className, row, full } = configuration;
    const { conditions } = this.state;
    const hasConditionalEditing = Boolean(properties.find(prop => prop.conditionalEditing));
    return (
      <div className={classNames('tuc-form-ctnr', className)}>
        <div className={classNames('tuc-form-content', !hasConditionalEditing && 'tuc-form-no-conditional-editing', row && 'form-content-row' || 'form-content-column', full && 'form-content-full')}>
          {properties
              .filter(property => !conditions[property.name] || conditions[property.name](data, this.props))
              .map((property) => {
            return (
              <FieldComponent
                key={property.name}
                {...this.props}
                property={property}
                fullWidth={!row || (Boolean(property.fullWidth))}
                fullHeight={Boolean(property.fullHeight)}
                onPropertyChange={this.handleChange(property.name)}
                useConditionalEditing={hasConditionalEditing}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default FormViewComponent;
